import _Swiper from './Swiper';

import './style/index.js';

export type { SwiperProps } from './Swiper';
export type { SwiperItemProps } from './SwiperItem';
export * from './type';

export const Swiper = _Swiper;

export default Swiper;
